import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { ButtonToolbar } from 'reactstrap';
import Loader from '../../../common/Loader';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import PrintManualSenderRemissionGuideButton from './PrintManualSenderRemissionGuideButton';
import {
  clearManualSenderRemissionGuide,
  getManualSenderRemissionGuide,
} from '../../../../actions/cargo/ManualSenderRemissionGuide';
import { MANUAL_SENDER_REMISSION_GUIDE_PATH } from '../../../../config/paths';
import RefreshManualSenderRemissionGuideButton from './RefreshManualSenderRemissionGuideButton';
import {
  BILL_PROCESS_STATUS_PROCESSED,
  GRR_MOTIVE_OTHERS,
} from '../../../../config/constants';
import ManualSenderRemissionGuideBasicInformationResource from './resource/ManualSenderRemissionGuideBasicInformationResource';
import PickupManualSenderRemissionGuideButton from './PickupManualSenderRemissionGuideButton';
import PrintContingencySenderRemmisionGuiderButton from './PrintContingencySenderRemmisionGuiderButton';

const ManualSenderRemissionGuide = (props) => {
  const {
    breadcrumbs,
    dispatchGetManualSenderRemissionGuide,
    dispatchClearManualSenderRemissionGuide,
    loading,
    match: {
      params: { id: SenderRemissionGuideId },
    },
    manualGrr,
  } = props;

  useEffect(() => {
    dispatchGetManualSenderRemissionGuide({ SenderRemissionGuideId });

    return () => {
      dispatchClearManualSenderRemissionGuide();
    };
  }, [SenderRemissionGuideId]);

  let grrJson = null;

  try {
    const raw = manualGrr.get('json');

    if (raw && raw !== 'undefined' && raw !== 'null') {
      grrJson = JSON.parse(raw);

      if (grrJson.remitente && typeof grrJson.remitente === 'string') {
        try {
          grrJson.remitente = JSON.parse(grrJson.remitente);
        } catch (err) {
          grrJson.remitente = null;
        }
      }

      if (grrJson.receiver && typeof grrJson.receiver === 'string') {
        try {
          grrJson.receiver = JSON.parse(grrJson.receiver);
        } catch (err) {
          grrJson.receiver = null;
        }
      }

      if (Array.isArray(grrJson.itemsList)) {
        grrJson.itemsList = grrJson.itemsList
          .map((item) => {
            if (typeof item === 'string') {
              try {
                return JSON.parse(item);
              } catch {
                return null;
              }
            }
            return item;
          })
          .filter(Boolean);
      }
    }
  } catch (e) {
    grrJson = null;
  }

  const toolbar = (
    <ButtonToolbar className="pull-right">
      <div>
        {(manualGrr.get('billProcessStatus') ===
          BILL_PROCESS_STATUS_PROCESSED ||
          (!manualGrr.get('billProcessStatus') && manualGrr.get('ticket'))) && (
          <PrintManualSenderRemissionGuideButton
            manualRemissionGuide={manualGrr}
          />
        )}{' '}
        {grrJson && grrJson.motiveId === GRR_MOTIVE_OTHERS && (
          <PickupManualSenderRemissionGuideButton manualGrr={manualGrr} />
        )}
        {manualGrr.get('billProcessStatus') !==
          BILL_PROCESS_STATUS_PROCESSED && (
          <>
            <RefreshManualSenderRemissionGuideButton
              manualRemissionGuide={manualGrr}
            />{' '}
            <PrintContingencySenderRemmisionGuiderButton
              contingencyRequest={grrJson}
            />
          </>
        )}
      </div>
    </ButtonToolbar>
  );

  let content = null;
  if (loading || manualGrr.isEmpty()) {
    content = <Loader />;
  } else {
    const manualGrrJson = manualGrr.toJS();

    content = (
      <ManualSenderRemissionGuideBasicInformationResource {...manualGrrJson} />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Guia de Remision Remitente"
      content={content}
      toolbar={toolbar}
    />
  );
};
ManualSenderRemissionGuide.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetManualSenderRemissionGuide: PropTypes.func.isRequired,
  dispatchClearManualSenderRemissionGuide: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  manualGrr: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ManualSenderRemissionGuide.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Guias de Remision Remitente',
      href: MANUAL_SENDER_REMISSION_GUIDE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  manualGrr: CargoUnit.ManualSenderRemissionGuide.getIn(['current', 'content']),
  loading: !CargoUnit.ManualSenderRemissionGuide.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetManualSenderRemissionGuide: getManualSenderRemissionGuide,
  dispatchClearManualSenderRemissionGuide: clearManualSenderRemissionGuide,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManualSenderRemissionGuide);
